export default function Features() {
  const items = [
    {
      icon: "ri-flashlight-line",
      title: "稳定更新不断更",
      desc: "精选长篇连载承诺持续更新，热门神作近乎日更，更新节奏清晰可查，彻底告别追更焦虑。",
      tone: "bg-primary-100 text-primary-600",
    },
    {
      icon: "ri-notification-3-line",
      title: "智能追更提醒",
      desc: "一键加入追更，系统记录你的阅读进度，最新一话上线即时提醒，不错过任何精彩篇章。",
      tone: "bg-accent-100 text-accent-600",
    },
    {
      icon: "ri-wallet-3-line",
      title: "免费在线阅读",
      desc: "所有长期连载漫画均免费在线阅读，不设付费门槛，让你无忧享受每一次追更体验。",
      tone: "bg-secondary-100 text-secondary-600",
    },
    {
      icon: "ri-layout-grid-line",
      title: "分类清爽好找",
      desc: "热血、科幻、奇幻、日常、悬疑、冒险六大题材清晰分类，快速定位你钟爱的长篇作品。",
      tone: "bg-primary-100 text-primary-600",
    },
  ];

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-sm font-bold text-primary-600">追更神器</p>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            为什么选择天天漫画网
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            围绕「长期连载 · 稳定更新」打造的一站式追更体验，让你安心追更每一天。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((f) => (
            <div
              key={f.title}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-6"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-full ${f.tone}`}
              >
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}